import { Box, Text, Badge } from "@mantine/core";
import EperuveTypeHeader from "./compenents/EpreuveTypeHeader";
import { parseNumber } from "../../parent/utils/numberUtils";

const EpreuveTypeOCandOD = ({ epreuve }) => {
    // Function to format the display of numbers and fractions
    const formatDisplay = (value) => {
        if (!value) return '';
        // If it's a fraction string, return it as is
        if (value.includes('/')) return value;
        // If it's a number, format it nicely
        const num = Number(value);
        return isNaN(num) ? value : num.toString();
    };

    return (
        <Box>
            <h1>Mettre dans l'ordre</h1>
            <EperuveTypeHeader epreuve={epreuve} />
            <Box my={10}>
                <Text weight={500}>Les nombres à ordonnés</Text>
                <Box mt={5}>
                    {epreuve?.consigne?.map((item, index) => {
                        try {
                            // Try to parse if it's a JSON string
                            const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
                            return (
                                <Badge
                                    key={index}
                                    color="gray"
                                    className="text-dark me-3"
                                    variant="outline"
                                    size="lg"
                                    style={{ fontSize: '1rem' }}
                                >
                                    {formatDisplay(parsedItem)}
                                </Badge>
                            );
                        } catch (e) {
                            // If parsing fails, display the raw value
                            return (
                                <Badge
                                    key={index}
                                    color="gray"
                                    className="text-dark me-3"
                                    variant="outline"
                                    size="lg"
                                    style={{ fontSize: '1rem' }}
                                >
                                    {formatDisplay(item)}
                                </Badge>
                            );
                        }
                    })}
                </Box>
            </Box>
            <Box mt={15}>
                <Text weight={500} className="mb-2">La correction</Text>
                <Box mt={5}>
                    {epreuve?.correction_dp?.map((item, index) => {
                        try {
                            // Try to parse if it's a JSON string
                            const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
                            return (
                                <Badge
                                    key={index}
                                    color="green"
                                    className="text-dark me-3"
                                    variant="filled"
                                    size="lg"
                                    style={{ fontSize: '1rem' }}
                                >
                                    {formatDisplay(parsedItem)}
                                </Badge>
                            );
                        } catch (e) {
                            // If parsing fails, display the raw value
                            return (
                                <Badge
                                    key={index}
                                    color="green"
                                    className="text-dark me-3"
                                    variant="filled"
                                    size="lg"
                                    style={{ fontSize: '1rem' }}
                                >
                                    {formatDisplay(item)}
                                </Badge>
                            );
                        }
                    })}
                </Box>
            </Box>
        </Box>
    );
}

export default EpreuveTypeOCandOD;